/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {data} from "./config/created-asset-description";

const MODULE_NAME = "AssetDescriptionService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class AssetDescriptionService {
    private static instance: AssetDescriptionService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): AssetDescriptionService {
        if (!AssetDescriptionService.instance) {
            AssetDescriptionService.instance = new AssetDescriptionService(
                props
            );
        }
        return AssetDescriptionService.instance;
    }

    async getAssetDescription() {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        console.log(`bla bla`)
        try {
            
            return data;
        } catch (err) {
            console.log(`error in assetDescSerivce`, err)
        }
    }
}
